

import React from 'react';

const TorontoSection = ({ data }) => {
  return (
    <section className="Toronto-section">
      <div className="container">
        <div className="inner-content">
          <div className="top-wrapper">
            <h2>{data.title}</h2>

            {data.paragraphs.map((para, index) => (
              <p key={index}>{para}</p>
            ))}

            <div className="bottom-wrapper">
              <div className="content-wrapper">
                <div className="left-wrapper">
                  <h3>Specialties</h3>
                  <ul>
                    {data.specialties.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="right-wrapper">
                  <h3>How we help:</h3>
                  <ul>
                    {data.howWeHelp.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TorontoSection;
